// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"56":"5ae576b0","295":"e277f55c","487":"2b14494e","654":"e3b28b23","766":"3417eafa"}[chunkId] + ".css";
};